<template>
    <div>

        <config-main-title v-if="!setup">
            Operadoras / Empresas
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3" v-if="!setup">
                <div class="col col-12 col-md-6">
                    <az-input
                        icon="fas fa-search"
                        ref="pesquisa"
                        v-model="search"
                        @input="selecionado = null"
                        @onArrowDown="onArrowDown"
                        @onArrowUp="onArrowUp"
                        @onEnter="onEnter">
                        <template v-slot:buttonposb>
                            <importacao service="operadoras" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Operadora
                    </button>
                </div>
            </div>

            <div class="mb-3 d-flex flex-column" v-else-if="lista && lista.length">
                <button type="button" class="btn btn-primary" @click="incluir ()">
                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                    Incluir Operadora
                </button>
            </div>

        </div>

        <div v-if="!em_edicao && ( !lista || !lista.length )">
            <az-empty-state icon="fas fa-search" msg="Nenhuma operadora identificada."
                :action="!search ? 'Incluir Operadora' : ''" :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg"
                    :class="id === selecionado ? 'active' : ''"
                    v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3"
                            :class="id === selecionado ? 'text-white' : ''">
                            {{ dado.search }}
                        </a>
                        <small class="text-muted ml-3">{{ dado.st_registro_ans }}</small>
                    </span>
                    <span class="d-flex">
                        <div v-if="dado.contrato_operadoras_count > 0" title="Contratos cadastrados">
                            <span class="badge badge-secondary mr-1">
                                <i class="fa-solid fa-c"></i>
                                {{ dado.contrato_operadoras_count }}
                            </span>
                        </div>

                        <div v-if="dado.planos_count > 0" title="Planos cadastrados">
                            <span class="badge badge-secondary mr-1">
                                <i class="fa-solid fa-p"></i>
                                {{ dado.planos_count }}
                            </span>
                        </div>

                        <div v-if="dado.restricao_operadoras_count > 0" title="Restrições cadastradas">
                            <span class="badge badge-secondary mr-1">
                                <i class="fa-solid fa-r"></i>
                                {{ dado.restricao_operadoras_count }}
                            </span>
                        </div>

                        <div v-if="dado.js_classes && dado.js_classes.length" class="mr-1">
                            <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                <span class="badge badge-success mr-1">
                                    {{ tag }}
                                </span>
                            </a>
                        </div>
                        <div v-if="1 == 0"
                            class="text-warning mr-3"
                            data-toggle="tooltip" data-placement="top" title="Nenhum prestador habilitado.">
                            <i class="fas fa-exclamation-triangle"></i>
                        </div>
                        <div class="custom-control custom-switch" v-if="1 == 0">
                            <input type="checkbox" class="custom-control-input" :id="'ativo-' + chave + '-' + ip"
                                v-model="proc.unidade_procedimento.fl_ativo"
                                @change="toggle_procedimento(proc.unidade_procedimento)">
                            <label class="custom-control-label" :for="'ativo-' + chave + '-' + ip"></label>
                        </div>
                        <div v-else>
                            <span v-if="1 == 0 && !dado.contrato_operadora" class="text-warning"
                                data-toggle="tooltip" data-placement="top" title="Contrato não cadastrado.">
                                <i class="fa fa-exclamation-triangle mr-3" aria-hidden="true"></i>
                            </span>
                            <span v-if="dado.status_operadora">
                                {{ dado.status_operadora.search }}
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição de procedimento -->

        <div v-if="em_edicao">

            <az-empty-state v-if="!item" />

            <template v-else>

                <!-- Planos -->
                <div v-if="submenu == 'planos'">
                    <planos ref="formulario" :id_operadora="item.id_operadora"></planos>
                </div>

                <!-- Tabelas e Valores -->
                <div v-else-if="submenu == 'tabelas-e-valores'">
                    <tabelas-e-valores ref="formulario" :id_operadora="item.id_operadora"></tabelas-e-valores>
                </div>

                <!-- Profissionais -->
                <div v-else-if="submenu == 'profissionais'">
                    <profissionais ref="formulario" :id_operadora="item.id_operadora"></profissionais>
                </div>

                <!-- Guias de Cobrança -->
                <div v-else-if="submenu == 'guias-de-cobranca'">
                    <guias-de-cobranca ref="formulario" :id_operadora="item.id_operadora" :registro_ans="item.st_registro_ans"></guias-de-cobranca>
                </div>

                <!-- Faturas -->
                <div v-else-if="submenu == 'faturas'">
                    <faturas ref="formulario" :id_operadora="item.id_operadora"></faturas>
                </div>

                <!-- Instruções -->
                <div v-else-if="submenu == 'instrucoes'">
                    <instrucoes-operadora ref="formulario" :id_operadora="item.id_operadora" :operadora="item"></instrucoes-operadora>
                </div>

                <!-- Restrições -->
                <div v-else-if="submenu == 'restricoes'">
                    <restricoes ref="formulario" :id_operadora="item.id_operadora"></restricoes>
                </div>

                <!-- Reduções -->
                <div v-else-if="submenu == 'reducoes'">
                    <reducao ref="formulario" :operadoras="lista" :id_operadora="item.id_operadora"></reducao>
                </div>

                <!-- Serviços Online -->
                <div v-else-if="submenu == 'servicos-online'">
                    <servicos-on-line ref="formulario" :id_operadora="item.id_operadora" />
                </div>

                <!-- Serviços Online -->
                <div v-else-if="submenu == 'contrato'">
                    <contrato-operadora ref="codcontrato" :id_operadora="item.id_operadora" />
                </div>

                <!-- Desconto Progressivo -->
                <div v-else-if="submenu == 'desconto-progressivo'">
                    <desconto-progressivo ref="desconto" :id_operadora="item.id_operadora" />
                </div>

                <!-- Empresa Operadora -->
                <div v-else-if="submenu == 'empresa-operadora'">
                    <empresa-operadora ref="empresaOperadora" :id_operadora="item.id_operadora" />
                </div>

                <!-- Operadora Medico Solicitante-->
                <div v-else-if="submenu == 'medicos-solicitantes'">
                    <operadora-medico-solicitante ref="operadoraMedicoSolicitante" :id_operadora="item.id_operadora" />
                </div>

                <!-- Operadora Medicos Cooperados-->
                <div v-else-if="submenu == 'cooperados'">
                    <medico-cooperado ref="cooperado" :id_operadora="item.id_operadora" />
                </div>

                <!-- Operadora Medicos Cooperados-->
                <div v-else-if="submenu == 'regra-de-cirurgia'">
                    <operadora-regra-cirurgia ref="regraCirurgia" :id_operadora="item.id_operadora" />
                </div>

                <!-- Dados da Operadora -->
                <div class="card" style="padding: 0px;" v-else>

                    <div class="card-header bg-success text-white lead" v-if="!item.id_operadora">
                        Nova Operadora
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <div class="row">
                                    <div class="col col-12" v-if="!item.fl_sus">
                                        <az-input
                                            label="Registro na ANS"
                                            :validate="validate"
                                            v-model="item.st_registro_ans"
                                            @input="buscar_ans()" />
                                    </div>
                                    <div class="col col-12">
                                        <az-input
                                            label="Nome da Operadora"
                                            required
                                            :edicao="!item.fl_sus"
                                            :validate="validate"
                                            v-model="item.st_operadora"/>
                                    </div>
                                    <div class="col col-12" v-if="!item.fl_sus">
                                        <az-input
                                            label="Site"
                                            :validate="validate"
                                            v-model="item.st_site"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-12 col-md-6" v-if="!item.fl_sus">
                                <div v-if="item.id_operadora" class="d-flex justify-content-end">
                                    <az-single-image-loader
                                        :single="true"
                                        :arquivo="item.logo"
                                        :parms="{ model_type: 'operadora', model_id: item.id_operadora }"
                                        service="operadoras"></az-single-image-loader>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Nome do Contato"
                                    :validate="validate"
                                    v-model="item.st_nome_contato" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Telefone do Contato"
                                    type="fone"
                                    :validate="validate"
                                    v-model="item.st_telefone_contato" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="e-mail do Contato"
                                    type="email"
                                    :validate="validate"
                                    v-model="item.st_email" />
                            </div>
                        </div>

                        <div class="row mt-3" v-if="item.fl_sus || !item.st_registro_ans">
                            <div class="col col-12 col-md-6" v-if="item.fl_sus || !item.st_registro_ans">
                                <az-input
                                    label="SUS"
                                    type="checkbox-group"
                                    v-model="item.fl_sus" />
                            </div>

                            <!--
                            <div class="col col-12 col-md-6" v-if="false">
                                <az-input
                                    type="checkbox-group"
                                    label="Não compor produção (Ex.: Cortesia)"
                                    v-model="item.fl_fora_producao" />
                            </div>
                            -->
                        </div>

                        <!-- Situação -->
                        <div v-if="item.id_operadora">

                            <az-sub-title class="mt-3" title="Situação" :big="true" />
                            <div class="row" v-if="item.status_operadora">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Status"
                                        icon="fas fa-pen"
                                        buttonText="fas fa-pen"
                                        :buttonIcon="true"
                                        buttonColor="outline-primary"
                                        :edicao="false"
                                        @clickButton="editarStatus ()"
                                        v-model="item.status_operadora.search" />
                                </div>
                            </div>

                            <az-sub-title class="mt-3" title="Histórico" />
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between" v-for="(status, ids) in item.status_operadoras" :key="ids">
                                    <span>
                                        <a href="#" @click.prevent="apagarStatus(status)" class="card-link text-danger mr-3" v-if="status.futuro">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </a>
                                        <i class="fas fa-play mr-3 text-muted" aria-hidden="true" v-if="item.status_operadora && item.status_operadora.id_status_operadora == status.id_status_operadora"></i>
                                        <span class="text-primary">{{ status.search }}</span> |
                                        <span class="text-muted">{{ status.dt_status_display }}</span> |
                                        <small class="text-muted">{{ status.usuario.st_login }}</small>
                                    </span>
                                    <small class="text-muted">
                                        {{ status.st_observacoes }}
                                    </small>
                                </li>
                            </ul>

                        </div>

                        <template v-if="!item.fl_sus">

                            <!-- Empresa -->
                            <az-sub-title class="mt-3" title="Empresa" :big="true" />
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Razão Social"
                                        required
                                        v-model="item.empresa.st_razao_social" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="Tipo"
                                        type="select"
                                        :optionsList="[
                                            { id: 'F', search: 'Física (CPF)' },
                                            { id: 'J', search: 'Jurídica (CNPJ)' },
                                        ]"
                                        optionsData="id"
                                        required
                                        v-model="item.empresa.tipo_pessoa" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        :label="( item.empresa.tipo_pessoa == 'F' ) ? 'CPF': 'CNPJ'"
                                        :type="( item.empresa.tipo_pessoa == 'F' ) ? 'cpf': 'cnpj'"
                                        required
                                        v-model="item.empresa.st_cnpj" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="Inscrição municipal"
                                        v-model="item.empresa.st_inscricao_municipal" />
                                </div>
                            </div>

                            <template v-if="!setup">

                                <cadastro-endereco v-model="item.empresa.endereco" :validate="validate" />

                                <!-- Telefones -->
                                <az-sub-title class="mt-3" title="Telefones" />
                                <cadastro-telefones v-model="item.empresa.telefone_empresas" :validate="validate" />

                                <!-- Outro Endereço para Faturamento -->
                                <div class="custom-control custom-switch mt-3">
                                    <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="item.outro_endereco_faturamento" @click="toggle_outro_endereco()">
                                    <label class="custom-control-label" for="customSwitch1">Utilizar outro endereço para faturamento</label>
                                </div>

                                <div v-if="item.outro_endereco_faturamento">
                                    <az-sub-title class="mt-3" title="Endereço para Faturamento" />
                                    <cadastro-endereco v-model="item.endereco" :validate="validate" />
                                </div>

                                <!-- Contrato -->
                                <template v-if="false">
                                    <az-sub-title class="mt-3" title="Contrato" :big="true" />
                                    <div>
                                        <div class="row">
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    label="Número do Contrato"
                                                    v-model="item.contrato_operadora.st_numero_contrato" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    label="Data do Contrato"
                                                    type="date"
                                                    :rule="['passado']"
                                                    :validate="validate"
                                                    v-model="item.contrato_operadora.dt_contrato" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    type="checkbox"
                                                    label="CNPJ como Código"
                                                    :validate="validate"
                                                    @input="item.contrato_operadora.cnpj_como_codigo ? ( item.contrato_operadora.st_numero_prestador = '' ) : '' "
                                                    v-model="item.contrato_operadora.cnpj_como_codigo" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    label="Código na Operadora"
                                                    :validate="validate"
                                                    :edicao="item.contrato_operadora && !item.contrato_operadora.cnpj_como_codigo"
                                                    :required="item.contrato_operadora && !item.contrato_operadora.cnpj_como_codigo"
                                                    v-model="item.contrato_operadora.st_numero_prestador" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <div v-if="item.id_operadora">
                                                    <div>
                                                        <small class="form-text text-muted text-nowrap text-truncate">
                                                            Arquivo
                                                        </small>
                                                    </div>
                                                    <div class="text-nowrap">
                                                        <az-single-image-loader
                                                            :showlink="true"
                                                            titulo="Arquivo"
                                                            :single="true"
                                                            :arquivo="item.contrato_operadora.logo"
                                                            :parms="{ model_type: 'contratoOperadora', model_id: item.contrato_operadora.id_contrato_operadora }"
                                                            service="contrato_operadoras" />
                                                    </div>
                                                </div>

                                                <az-input
                                                    v-if="1 == 0"
                                                    label="Arquivo do Contrato"
                                                    :validate="validate"
                                                    v-model="item.contrato_operadora.st_nome_arquivo_contrato" />

                                            </div>
                                        </div>

                                        <pre v-if="1 == 0">{{ item.contrato_operadora.logo }}</pre>

                                        <div v-if="item.id_operadora">
                                            <az-sub-title class="mt-3" title="Ajustes de Contrato" />
                                            <table class="table table-responsive-md">
                                                <tbody>
                                                    <tr v-for="(ajuste_contrato, iaj) in item.contrato_operadora.contrato_ajuste_operadoras" :key="iaj">
                                                        <td>
                                                            {{ $util.getFormatDate(ajuste_contrato.dt_ajuste) }}
                                                        </td>
                                                        <td>
                                                            {{ ajuste_contrato.st_observacao }}
                                                        </td>
                                                        <td>
                                                            <div class="text-nowrap">
                                                                <az-single-image-loader
                                                                    :showlink="true"
                                                                    titulo="Arquivo"
                                                                    :single="true"
                                                                    :arquivo="ajuste_contrato.logo"
                                                                    :parms="{ model_type: 'contratoAjusteOperadora', model_id: ajuste_contrato.id_contrato_ajuste_operadora }"
                                                                    service="contrato_ajuste_operadoras"
                                                                    :chave="iaj" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <button type="button" class="btn btn-outline-secondary btn-sm" onclick="javascript:alert('em desenvolvimento')">
                                                Incluir Ajuste de Contrato
                                            </button>
                                        </div>

                                    </div>

                                </template>

                                <!-- Outras Informações -->
                                <az-sub-title class="mt-3" title="Outras Informações" :big="true" />
                                <div class="row">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            type="checkbox"
                                            label="Exigir matrícula"
                                            v-model="item.fl_exigir_matricula" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Qtd de Dígitos da Matrícula"
                                            type="number"
                                            v-model="item.in_quantidade_digitos_matricula" />
                                    </div>
                                    <div class="col col-12 col-md-3" v-if="item.in_quantidade_digitos_matricula">
                                        <az-input
                                            label="Qtd de Dígitos Máximo da Matrícula"
                                            type="number"
                                            v-model="item.in_quantidade_digitos_matricula_maximo" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Início da Matrícula"
                                            v-model="item.st_inicial_matricula" />
                                    </div>
                                    <div class="col col-12 col-md-6" v-if="1 == 0">
                                        <az-input
                                            label="Fórmula de Dígito Verificador"
                                            v-model="item.st_digito_verificador_matricula"  />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="select"
                                            label="Tipo de Revisão"
                                            service="tipoDeRevisao"
                                            optionsMode="json"
                                            :optionsList="[{ id: 'E', search: 'Por Especialidade' }, { id: 'M', search: 'Por Médico' }]"
                                            optionsData="id"
                                            optionsDisplay="search"
                                            v-model="item.ch_tipo_revisao" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="number"
                                            label="Prazo de Revisão"
                                            v-model="item.in_prazo_revisao" />
                                    </div>
                                </div>

                                <!-- Revisões por Especialidade -->
                                <div class="mb-4">
                                    <az-sub-title class="mt-3" title="Revisões por Especialidade">
                                        <a href="#" @click.prevent="incluirRevisao ()">
                                            <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                            Incluir
                                        </a>
                                    </az-sub-title>
                                    <div v-if="!item.revisoes.filter(rev => !rev.excluido).length">
                                        Nenhuma especialidade definida com prazo de revisão diferente do padrão.
                                    </div>

                                    <div v-for="(revisao, irx) in item.revisoes" :key="irx">
                                        <div class="row" v-if="!revisao.excluido">
                                            <div class="col col-12 col-md-6">
                                                <az-input
                                                    sizing="sm"
                                                    :validate="validate"
                                                    v-model="revisao.id_especialidade"
                                                    required
                                                    type="select"
                                                    optionsMode="aql"
                                                    optionsData="id_especialidade"
                                                    :optionsSync="false"
                                                    service="especialidades.index"
                                                    icon="fas fa-trash-alt"
                                                    :buttonIcon="true"
                                                    buttonText="fas fa-minus"
                                                    buttonColor="outline-danger"
                                                    @clickButton="revisao.excluido = true" />
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <az-input
                                                    sizing="sm"
                                                    :compact="true"
                                                    type="number"
                                                    label="Prazo de Revisão"
                                                    v-model="revisao.in_prazo_dias">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <span class="input-group-text">(dias)</span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </template>

                        </template>

                        <template>

                            <template v-if="!setup">

                                <div class="row mt-3">
                                    <div class="col col-12">
                                        <az-input
                                            type="checkbox-group"
                                            label="Emite nota fiscal no momento do faturamento"
                                            v-model="item.fl_nota_fiscal" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            type="checkbox-group"
                                            label="Permitir agendamento on-line pelo portal do paciente"
                                            v-model="item.fl_agenda_online" />
                                    </div>
                                </div>

                                <div class="row" v-if="1 == 0">
                                    <div class="col col-12">
                                        <az-input
                                            type="checkbox-group"
                                            label="Permite itens com valor 0,00 na guia"
                                            v-model="item.fl_valor_zero_guia" />
                                    </div>
                                </div>

                                <!-- Impostos -->
                                <az-sub-title class="mt-3" title="Impostos" :big="true">
                                    Total de Retenção: {{ total_retencao () }}%
                                </az-sub-title>

                                <div class="row">
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="money"
                                            label="PIS (%)"
                                            :required="item.fl_retem_pis"
                                            v-model="item.dc_pis" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="checkbox"
                                            label="Reter PIS"
                                            v-model="item.fl_retem_pis" />
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="money"
                                            label="COFINS (%)"
                                            :required="item.fl_retem_cofins"
                                            v-model="item.dc_cofins" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="checkbox"
                                            label="Reter COFINS"
                                            v-model="item.fl_retem_cofins" />
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="money"
                                            label="CSLL (%)"
                                            :required="item.fl_retem_csll"
                                            v-model="item.dc_csll" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="checkbox"
                                            label="Reter CSLL"
                                            v-model="item.fl_retem_csll" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="money"
                                            label="INSS (%)"
                                            :required="item.fl_retem_inss"
                                            v-model="item.dc_inss" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="checkbox"
                                            label="Reter INSS"
                                            v-model="item.fl_retem_inss" />
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="money"
                                            label="ISS (%)"
                                            :required="item.fl_retem_iss"
                                            v-model="item.dc_iss" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="checkbox"
                                            label="Reter ISS"
                                            v-model="item.fl_retem_iss" />
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="money"
                                            label="IRRF (%)"
                                            :required="item.fl_retem_irrf"
                                            v-model="item.dc_irrf" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            type="checkbox"
                                            label="Reter IRRF"
                                            v-model="item.fl_retem_irrf" />
                                    </div>
                                </div>
                                <!-- Desativado pelo PowerP -->
                                <div class="row mt-3" v-if="false">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            
                                            type="checkbox-group"
                                            label="Impostos Federais (POWERP)"
                                            v-model="item.fl_impostos_federais" />
                                    </div>
                                </div>

                            </template>

                        </template>

                        <template v-if="!setup">

                            <!-- Observação -->
                            <az-sub-title class="mt-3" title="Atendimento de Urgência / Emergência" :big="true" />
                            <p class="alert alert-info">
                                Os atos médicos praticados em caráter de urgência ou emergência terão um acréscimo de trinta por cento (30%) em seus portes nas seguintes eventualidades.
                            </p>

                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="select"
                                        label="Tipo"
                                        :optionsList="[
                                            { id: 'C', search: 'Padrão CBHPM' },
                                            { id: 'S', search: 'Sem adicional de urgência' },
                                            { id: 'P', search: 'Personalizado' },
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="item.ch_tipo_hor_urg" />
                                </div>
                                <template v-if="item.ch_tipo_hor_urg == 'P'">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Início Dia Útil"
                                            type="time"
                                            required
                                            :validate="validate"
                                            v-model="item.hr_inicio_urgencia_dia_util" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Fim Dia Útil"
                                            type="time"
                                            required
                                            :validate="validate"
                                            v-model="item.hr_fim_urgencia_dia_util" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Início Sábado"
                                            type="time"
                                            required
                                            :validate="validate"
                                            v-model="item.hr_inicio_urgencia_sabado" />
                                    </div>
                                </template>
                            </div>

                            <template v-if="item.ch_tipo_hor_urg == 'C'">
                                <p class="alert alert-secondary">
                                    No período compreendido entre 19h e 7h do dia seguinte de segunda a sexta; Em qualquer horário aos sábados, domingos e feriados;
                                </p>
                            </template>

                            <template v-if="item.ch_tipo_hor_urg == 'S'">
                                <p class="alert alert-secondary">
                                    Nenhum adicional urgência será lançando.
                                </p>
                            </template>

                            <template v-if="item.ch_tipo_hor_urg == 'P'">
                                <p class="alert alert-secondary">
                                    Além da cobrança em domingos e feriados.
                                </p>
                            </template>

                            <!-- Observação -->
                            <az-sub-title class="mt-3" title="Observação" :big="true">
                            </az-sub-title>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        type="textarea"
                                        rows="5"
                                        v-model="item.st_observacao" />
                                </div>
                            </div>

                            <!-- Classificação -->
                            <div class="row mt-3">
                                <div class="col col-12">
                                    <small class="text-muted">Classificação</small>
                                    <multiselect
                                        v-model="item.js_classes"
                                        :options="options_classes"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addTag"
                                        placeholder="Selecione uma classificação..."
                                        selectLabel="Pressione [ENTER] para selecionar"
                                        deselectLabel="Pressione [ENTER] para remover"
                                        tagPlaceholder="Pressione [ENTER] para incluir"
                                        selectedLabel="Selecionado">
                                        <template slot="noOptions">
                                            Nenhuma classificação criada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                            <!-- Campos Customizados -->
                            <div v-if="item.campos_customizados" class="row mt-3">
                                <div class="col col-12">
                                    <az-sub-title :title="item.campos_customizados.st_titulo" :big="true" />
                                    <formulario
                                        :gutters="true"
                                        :validate="validate"
                                        v-model="item.campos_customizados.js_campos"
                                        :saved="true"
                                        mode="fixed"
                                        :config="true" />
                                </div>
                            </div>

                            <!-- Cobertura de Pacote -->
                            <filtro-model class="my-3" title="Filtros para Cobertura de Pacote" :big="true" v-model="item.pacote_filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        </template>

                    </div>
                </div>

                <!-- Botões de Atualização -->

                <nav class="navbar fixed-bottom navbar-light bg-light pb-3">

                    <div v-if="submenu == 'Dados da Operadora' || submenu == 'dados-da-operadora' || submenu == 'faturas' || submenu == 'servicos-online' || submenu == 'guias-de-cobranca'">
                        <az-submit class="mr-2" @click="atualizar ()" v-if="exibir_atualizar">Atualizar</az-submit>
                        <button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
                        <az-audit-log-button model="operadora" class="mr-2" :id="item.id_operadora" />
                        <button class="btn btn-outline-primary mr-2" @click="incluir ()" v-if="item.id_operadora">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>

                        <a href="#" @click.prevent="preencher_enquente(item)" 
                            v-if="item.id_operadora"
                            class="btn mr-2" 
                            :class="item.enquetes_aplicadas_count > 0 ? 'btn-dark' : 'btn-outline-dark'"
                            title="Avaliação (Enquetes)">
                            <i class="fa-solid fa-clipboard-check"></i>
                            <span v-if="item.enquetes_aplicadas_count" class="badge badge-light ml-1">
                                {{ item.enquetes_aplicadas_count }}
                            </span>
                        </a>

                        <span class="ml-3 h5">{{ item.st_operadora }}</span>
                    </div>

                    <div v-else>
                        <button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
                        <span class="ml-3 h5">{{ item.st_operadora }}</span>
                    </div>

                    <div class="btn-group dropup" style="min-width: 200px;" v-if="item.id_operadora">
                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ submenu }}
                        </button>
                        <div class="dropdown-menu">
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Dados da Operadora') ">Dados da Operadora</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Planos') ">Planos</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Tabelas e Valores') " v-if="!setup">Tabelas e Valores</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Profissionais') " v-if="!setup">Profissionais</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Contrato') " v-if="!setup">Contrato</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Guias de Cobrança') ">Guias de Cobrança</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Faturas') " v-if="!setup">Faturas</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Instruções') " v-if="!setup">Instruções</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Restrições') " v-if="!setup">Restrições</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Reduções') " v-if="!setup">Reduções</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Serviços Online') " v-if="!setup && !item.fl_sus">Serviços Online</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Desconto Progressivo') " v-if="!setup && !item.fl_sus">Desconto Progressivo</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Empresa Operadora') " v-if="!setup">Empresas</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Médicos Solicitantes') " v-if="!setup">Médicos Solicitantes</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Cooperados') " v-if="!setup">Cooperados</button>
                            <button class="dropdown-item" @click.prevent=" selec_submenu('Regra de Cirurgia') " v-if="!setup">Regra de Cirurgia</button>
                        </div>
                    </div>

                </nav>

            </template>

            <!-- Modal -->
            <div class="modal fade" id="statusModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Situação</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        type="select"
                                        optionsMode="json"
                                        service="statusHistorico"
                                        :optionsList="[{ id: 'A', search: 'Ativo'},{ id: 'C', search: 'Cancelado'},{ id: 'S', search: 'Suspenso'}]"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        label="Status"
                                        required
                                        :validate="validate"
                                        v-model="edicaoStatus.ch_status" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        type="date"
                                        label="Data"
                                        required
                                        :validate="validate"
                                        v-model="edicaoStatus.dt_status" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        type="text"
                                        label="Observação"
                                        v-model="edicaoStatus.st_observacoes" />
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit @click="atualizarStatus ()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <enquete ref="enquete" @refresh="editar(item)" />

        <br><br><br>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import Planos from './Operadora/Planos.vue';
import TabelasEValores from './Operadora/TabelasEValores.vue';
import Profissionais from './Operadora/Profissionais.vue';
import GuiasDeCobranca from './Operadora/GuiasDeCobranca.vue';
import Faturas from './Operadora/Faturas.vue';
import InstrucoesOperadora from './Operadora/InstrucoesOperadora.vue';
import Restricoes from './Operadora/Restricoes.vue';
import Reducao from './Operadora/Reducao.vue';
import ServicosOnLine from './Operadora/ServicosOnLine.vue';
import ContratoOperadora from './Operadora/ContratoOperadora.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import CadastroTelefones from '../../shared/CadastroTelefones.vue';
import AzSingleImageLoader from '../../util/AzSingleImageLoader.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Importacao from '../shared/Importacao.vue';
import Multiselect from 'vue-multiselect';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import DescontoProgressivo from './Operadora/DescontoProgressivo.vue';
import EmpresaOperadora from "./Operadora/EmpresaOperadora.vue";
import FiltroModel from '../shared/FiltroModel.vue';
import Enquete from '../../shared/Enquete.vue';
import OperadoraMedicoSolicitante from './Operadora/OperadoraMedicoSolicitante.vue';
import MedicoCooperado from './Operadora/MedicoCooperado.vue';
import OperadoraRegraCirurgia from './Operadora/OperadoraRegraCirurgia.vue';

//import AzBreakTitle from '../../util/AzBreakTitle.vue';

export default {
    data () {
        return {
            especialidade: null,
            search: "",
            dados: null,
            em_edicao: false,
            item: null,
            tabelas: null,
            medicos: null,
            validate: false,
            submenu: "Dados da Operadora",
            edicaoStatus: {
                ch_status: null,
                dt_status: null,
                st_observacoes: null,
            },
            viewMode: "A",
            options_classes: [],
            selecionado: null, 
        }
    },

    props: ['id_operadora', 'go_submenu', 'link', 'setup'],

    components: {
        ConfigMainTitle,
        AzInput,
        AzSubTitle,
        CadastroEndereco,
        Planos,
        TabelasEValores,
        Profissionais,
        GuiasDeCobranca,
        Faturas,
        InstrucoesOperadora,
        Restricoes,
        AzSubmit,
        CadastroTelefones,
        AzSingleImageLoader,
        AzAuditLogButton,
        ServicosOnLine,
        Reducao,
        ContratoOperadora,
        Importacao,
        Multiselect, 
        Formulario, 
        DescontoProgressivo, 
        EmpresaOperadora,
        FiltroModel, 
        Enquete,
        OperadoraMedicoSolicitante,
        MedicoCooperado, 
        OperadoraRegraCirurgia,
    }, 

    watch: {
        '$store.state.unidade': function () {
            this.load();

            if ( this.item )
                this.editar (this.item);
        }
    },

    computed: {
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'tag-material', search:'Classificação do Material', service: 'materiais.index', parms: { ativos: true }, tag: true}, 
                {id:'tag-medicamento', search:'Classificação do Medicamento', service: 'medicamentos.index', parms: { ativos: true }, tag: true}, 
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\material', search:'Material', service: 'materiais.index', parms: { ativos: true }},
                {id:'App\\azure\\medicamento', search:'Medicamento', service: 'medicamentos.index', parms: { ativos: true }},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\recepcao', search:'Recepção', service: 'recepcaos.index', parms: { filtros: true }},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'}
            ];
            
            return opcoes;
        },

        exibir_atualizar: function () {

            switch (this.submenu) {
                case 'Planos':
                case 'Profissionais':
                case 'Instruções':
                case 'Restrições':
                case 'Tabelas e Valores':
                case 'Reduções':
                case 'Contrato':
                    return false;
            }

            return true;

        },
        lista: function () {
            let pesquisar = this.search.trim();

            if ( pesquisar && pesquisar.toUpperCase() == 'SUS' ) { 
                pesquisar = '"' + pesquisar + '"';
            }

            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ?
                this.dados.filter(item => this.viewMode != "A" || ( item.status_operadora && item.status_operadora.search == 'Ativo' ) )
                .filter (item => {
                    return !this.search || reg.test(JSON.stringify(item));
                }) : null ;
        }
    },

    methods: {
        preencher_enquente(item) { 
            this.$refs.enquete.abrir(item, 'App\\azure\\operadora', 'id_operadora');
        },

        incluirRevisao () { 
            this.item.revisoes.push({
                id_operadora_revisao: null, 
                excluido: false, 
                id_especialidade: null,
                in_prazo_dias: 30,
            });
        },

        slugify(str) {
            return String(str)
                .normalize('NFKD') // split accented characters into their base characters and diacritical marks
                .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
                .trim() // trim leading or trailing whitespace
                .toLowerCase() // convert to lowercase
                .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
                .replace(/\s+/g, '-') // replace spaces with hyphens
                .replace(/-+/g, '-'); // remove consecutive hyphens
        },

        selec_submenu (submenu) { 

            submenu = this.slugify(submenu);

            if ( submenu != this.go_submenu ) { 
              this.$router.push({ name: 'c-operadoras', params: { id_operadora: this.item.id_operadora, go_submenu: submenu } });
              this.submenu = submenu;
              return;
            }

        },

        toggle_outro_endereco() { 
            if ( !this.item.endereco ) { 
                this.item.endereco = {};
                this.$forceUpdate();
            }
        },

        onArrowDown () { 
            if ( this.selecionado === null ) {
                this.selecionado = 0;
            } else { 
                this.selecionado ++;
            }
		},

		onArrowUp () { 
			if ( this.selecionado > 0 ) { 
				this.selecionado --;
			}			
		},

		onEnter () { 
            if ( _.get(this.lista, this.selecionado) ) { 
                this.editar(this.lista[this.selecionado])
            }
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        buscar_ans () {
            if ( !this.item.id_operadora && this.item.st_registro_ans && this.item.st_registro_ans.length == 6 ) {

                this.$util.loadItem(this, {
                    service: 'operadoras',
                    func: 'buscar_ans',
                    parms: {
                        reg_ans: this.item.st_registro_ans,
                    }
                })
                .then(res => {
                    this.item.st_operadora = res.nome;
                    this.item.empresa.st_razao_social = res.razao_social;
                    this.item.empresa.st_cnpj = res.cnpj ? res.cnpj : this.item.empresa.st_cnpj;
                    this.item.st_site = res.site ? res.site : this.item.st_site;

                    if ( res.operadora ) {

                        this.$toast.add({
                            severity: "warn",
                            summary: "Atenção",
                            detail: "Operadora já cadastrada: " + res.nome,
                            life: 3000
                        });

                    }
                });

            }

        },

        editarStatus () {

            this.validate = false;

            this.edicaoStatus = {
                id_operadora: this.item.id_operadora,
                ch_status: null,
                dt_status: null,
                st_observacoes: null,
            }

            $('#statusModal').modal('show');
        },

        apagarStatus(status) {

            this.$util.atualizar(this, {
                service: 'status_operadoras',
                func: 'destroy',
                dados: {
                    id_status_operadora: status.id_status_operadora
                },
                callback: () => {
                    this.editar(this.item);
                }
            });

        },

        atualizarStatus () {

            this.$util.atualizar(this, {
                service: 'status_operadoras',
                dados: { ...this.edicaoStatus },
                modal: 'statusModal',
                reload: true,
                callback: () => {
                    this.editar(this.item);
                }
            });

        },

        total_retencao () {
            return this.$util.formatMoeda(
                ( this.item.fl_retem_pis ? this.item.dc_pis : 0 ) +
                ( this.item.fl_retem_cofins ? this.item.dc_cofins : 0 ) +
                ( this.item.fl_retem_csll ? this.item.dc_csll : 0 ) +
                ( this.item.fl_retem_inss ? this.item.dc_inss : 0 ) +
                ( this.item.fl_retem_iss ? this.item.dc_iss : 0 ) +
                ( this.item.fl_retem_irrf ? this.item.dc_irrf : 0 )
            );
        },
        abrirTabela (tabela) {
            let filtro_item = {};

            if ( tabela.procedimento_item_tabela.item_tabela ) {
                filtro_item = { id_item_tabela: tabela.procedimento_item_tabela.item_tabela.id_item_tabela };
            }

            this.$router.push({
                name: 'c-tabelas',
                params: {
                    id_tabela_versao: tabela.id_tabela_versao,
                    ...filtro_item,
                }
            });
        },
        abrirMedico (medico) {
            this.$router.push({
                name: 'c-prestadores',
                params: {
                    id_medico: medico.id_pessoa
                }
            });
        },
        incluir () {
            this.submenu = "Dados da Operadora";
            this.validate = false;

            this.item = {
                id_operadora: null,
                ch_tipo_revisao: 'E',
                in_prazo_revisao: 30,
                empresa: {
                    tipo_pessoa: "J", 
                    st_cnpj: "", 
                    endereco: {},
                    telefone_empresas: [],
                },
                contrato_operadora: {
                    cnpj_como_codigo: true,
                    st_numero_prestador: "",
                    contrato_ajuste_operadoras: [],
                },
                revisoes: [], 
                pacote_filtros: [], 
            };

            this.em_edicao = true;
        },
        load () {
            this.$store.commit('loading', true);

            let filtro = {};

            if ( this.id_operadora && this.link ) {
                // filtro = { where: { id_operadora: this.id_operadora } };
            }

            let query = { q: [
                {
                    name: 'operadoras.index',
                    id: 'lista',
                    parms: {
                        cadastro: true,
                        ...filtro,
                    }
                }
            ]};

            this.axios.post('/aql?a=operadoras.index', query)
                .then(res => {
                    if ( res.data.lista.status == 200 ) {
                        this.dados = res.data.lista.data;

                        if ( this.id_operadora ) {
                            let item = this.dados.find(item => item.id_operadora == this.id_operadora);
                            this.editar (item);
                        }
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });
        },
        editar (item) {
            this.validate = false;

            if ( !this.em_edicao ) {
                this.$store.commit('loading', true);
                this.item = null;
                this.em_edicao = true;

                if ( !this.setup ) {
                    this.$router.replace({ name: 'c-operadoras', params: { id_operadora: item.id_operadora, go_submenu: this.slugify(this.submenu) }});
                }
            }

            let query = { q: [
                {
                    name: 'operadoras.show',
                    id: 'operadora',
                    parms: {
                        id: item.id_operadora,
                        cadastro: true,
                    }
                }
            ]};

            this.axios.post('/aql?a=operadoras.show', query)
                .then(res => {

                    if ( !this.em_edicao ) {
                        window.scroll(0,0);
                    }

                    if ( res.data.operadora.status == 200 ) {
                        let oper = res.data.operadora.data;

                        if ( !oper.empresa ) {
                            oper.empresa = {
                                endereco: {},
                                telefone_empresas: [],
                            };
                        }

                        if ( !oper.endereco ) {
                            oper.endereco = {};
                        }

                        if ( !oper.contrato_operadora ) {
                            oper.contrato_operadora = {
                                cnpj_como_codigo: true,
                                st_numero_prestador: "",
                                contrato_ajuste_operadoras: [],
                            };
                        }

                        this.item = oper;
                        this.em_edicao = true;

                        if ( this.item.search && !this.setup ) {
                            let bc = _.cloneDeep(this.breadcrumb);
                            bc.push({ name: this.item.search, path: "" });
                            this.$store.commit('setBreadcrumb', bc);
                        }
                    }

                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

        },
        atualizar () {

            console.log('op', this.item);

            if ( this.submenu != 'Dados da Operadora' && this.submenu != 'dados-da-operadora' ) {

                this.$refs.formulario.atualizar ();

            } else {

                this.validate = true;

                this.$nextTick (() => {

                    let invalids = $('.invalid');

                    if ( invalids.length && $('.invalid').is(':visible') ) {

                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Verificar preenchimento dos campos.",
                            life: 3000
                        });

                    } else {

                        this.$store.commit('loading', true);

                        let query = { q: [
                            {
                                name: 'operadoras.store',
                                id: 'atualizar',
                                parms: {
                                    ...this.item,
                                }
                            }
                        ]};

                        if ( this.item.id_procedimento ) {

                            query.q.push({
                                name: 'procedimento_item_tabelas.store',
                                id: 'tabelas',
                                parms: {
                                    ...this.tabelas,
                                }
                            });

                            query.q.push({
                                name: 'medico_unidades.update_procedimento',
                                id: 'medicos',
                                parms: {
                                    ...this.medicos,
                                }
                            });

                        }

                        this.axios.post('/aql', query)
                            .then (res => {
                                if ( res.data.atualizar.status == 200 ) {
                                    this.load();

                                    if ( !this.item.id_operadora ) {
                                        this.editar (res.data.atualizar.data);
                                    }

                                    this.$toast.add({
                                            severity: "success",
                                            summary: "Atenção",
                                            detail: "Cadastro atualizado.",
                                            life: 3000
                                        });
                                }
                            })
                            .finally(() => {
                                this.$store.commit('loading', false);
                            });

                    }

                });

            }

        },
        fechar () {
            if ( this.id_operadora && this.link ) {
                this.$router.go(-1);
            } else {
                if ( this.$route.path != '/config/operadoras' && !this.setup ) {
                    this.$router.replace({ name: 'c-operadoras' });
                }

                this.em_edicao = false;

                if ( !this.setup ) {
                    this.$store.commit('setBreadcrumb', this.breadcrumb);

                    this.$nextTick(() => { 
                        this.$refs['pesquisa'].$refs.input.focus ();
                    });
                }
            }
        },
        toggle_procedimento (item) {

            this.$store.commit('loading', true);

            let query = { q: [
                {
                    name: 'unidade_procedimentos.toggle',
                    id: 'toggle',
                    parms: {
                        incluir: true,
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.toggle.status == 200 ) {
                        let result = res.data.toggle.data;
                        item.id_unidade_procedimento = result.id_unidade_procedimento;
                        item.fl_ativo = result.fl_ativo;
                        item.quebra = result.fl_ativo;
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });


        },

    },

    created () {

        if ( this.$store.state.contexto.especialidade ) {

            let lista = this.$store.state.options['esp-ativas'];

            if ( lista ) {
                let item = lista.find(it => {
                    return it.id_especialidade == this.$store.state.contexto.especialidade;
                });

                if ( item ) {
                    this.especialidade = item;
                }
            }

        }

    },

    mounted () {
        if ( this.id_operadora && !this.link ) {
            this.link = true;
        }

        if ( this.go_submenu )
            this.submenu = this.go_submenu;
            

        this.load ();

        if ( !this.setup ) {
            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Operadoras - Empresas", method: this.fechar },
                ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

            this.$refs['pesquisa'].$refs.input.focus ();
        }

        this.$util.loadItem(this, { 
            service: 'operadoras',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });
    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>